import { Component, Input } from '@angular/core';
import { getOptions } from '../../services/unit-library';
import { UsersService } from '../../services/users-service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-units-convert',
  templateUrl: './units-convert.component.html',
  standalone: false
})
export class UnitsConvertComponent {
  public unitTypes = [
    { name: "Area", value: "area" },
    { name: "Density", value: "density" },
    { name: "Dogleg Severity", value: "doglegSeverity" },
    { name: "Enthalpy", value: "enthalpy" },
    { name: "Force", value: "force" },
    { name: "Gas Gradient", value: "gasGradient" },
    { name: "Gas Flow Rate", value: "gasInjectionRate" },
    { name: "Heat", value: "heat" },
    { name: "Heat Transfer Coefficient", value: "heatTransferCoefficient" },
    { name: "Hydrocarbon Flow", value: "hydrocarbonFlow" },
    { name: "K Prime", value: "kPrime" },
    { name: "Long Lengths", value: "longLengths" },
    { name: "Mass Flow", value: "massFlow" },
    { name: "Power", value: "power" },
    { name: "Plastic Viscosity", value: "plasticViscosity" },
    { name: "Pressure", value: "pressure" },
    { name: "Pressure Loss", value: "pressureLoss" },
    { name: "Short Lengths", value: "shortLengths" },
    { name: "Slurry Flow Rate", value: "slurryFlow" },
    { name: "Solids Density", value: "solidsDensity" },
    { name: "Specific Heat Capacity", value: "specificHeatCapacity" },
    { name: "Speed", value: "speed" },
    { name: "Standard Fluid Flow", value: "standardFluidFlow" },
    { name: "Stress Pressure", value: "stressPressure" },
    { name: "Temperature", value: "temperature" },
    { name: "Temperature Gradient", value: "temperatureGradient" },
    { name: "Thermal Conductivity", value: "thermalConductivity" },
    { name: "Thermal Expansion Coefficient", value: "thermalExpansionCoefficient" },
    { name: "Torque", value: "torque" },
    { name: "Volume", value: "volume" },
    { name: "Weight Per Length", value: "linearDensity" },
    { name: "Yield Point", value: "yieldPoint" }
];

  //Used for state management
  @Input()
  private componentId: string;

  public selectedUnitType: string;
  public fromValue: number;
  public convertedUnit: number;
  public toValue: number;
  public toUnit: string;
  public fromUnit: string;
  public unitOptions = [];

  constructor(private _usersService: UsersService) {}

  public selectedUnitTypeChange(event: any, dropdown: any) {
    if (event.value == 'thermalExpansionCoefficient') {
      event.value = 'coefficientOfThermalExpansion';
    }
    this.unitOptions = getOptions(event.value);
    this.fromUnit = this.unitOptions[0].value;
    this.toUnit = this.unitOptions[1].value;
    this.fromValue = null;
    this.convertedUnit = null;
    dropdown.resetFilter();
  }

  public async convertUnits() {
    let unitType = "Unit" + this.unitTypes.find(x => x.value === this.selectedUnitType)?.value?.replace(/^./, c => c.toUpperCase());
    const toUnitSymbol = this.unitOptions.find(x => x.value == this.toUnit).value;
    const fromUnitSymbol = this.unitOptions.find(x => x.value == this.fromUnit).value;

    if (unitType.includes('SlurryFlow')) {
      unitType += 'Rate';
    }
    
    if (!this.fromValue || !this.toUnit || !this.fromUnit) {
      this.convertedUnit = null;
      return;
    }
    this.convertedUnit = await lastValueFrom(this._usersService.convertUnits(this.fromValue, unitType, toUnitSymbol, fromUnitSymbol));
  }
}
